import { useEffect } from 'react'

const useClickOutside = (
	ref: React.RefObject<HTMLElement>,
	callback: () => void,
	ignoreSelector?: string
) => {
	const handleClickOutside = (event: MouseEvent) => {
		if (
			ref.current &&
			!ref.current.contains(event.target as Node) &&
			(!ignoreSelector || !(event.target as Element).closest(ignoreSelector))
		) {
			callback()
		}
	}

	useEffect(() => {
		document.addEventListener('mousedown', handleClickOutside)
		return () => {
			document.removeEventListener('mousedown', handleClickOutside)
		}
	}, [ref, callback])
}

export default useClickOutside
